module.exports = __webpack_public_path__ + "static/media/yadho.26df29eb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/yadho.png
 ** module id = 210
 ** module chunks = 0
 **/